import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Site\GetSiteActivitiesByIdController::__invoke
* @see app/Http/Controllers/Site/GetSiteActivitiesByIdController.php
* @route '/api/site/{site}/activities'
*/
const GetSiteActivitiesByIdController = (args: { site: string | number | { id: string | number } } | [site: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetSiteActivitiesByIdController.url(args, options),
    method: 'get',
})

GetSiteActivitiesByIdController.definition = {
    methods: ["get","head"],
    url: '/api/site/{site}/activities',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Site\GetSiteActivitiesByIdController::__invoke
* @see app/Http/Controllers/Site/GetSiteActivitiesByIdController.php
* @route '/api/site/{site}/activities'
*/
GetSiteActivitiesByIdController.url = (args: { site: string | number | { id: string | number } } | [site: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { site: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { site: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            site: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        site: typeof args.site === 'object'
        ? args.site.id
        : args.site,
    }

    return GetSiteActivitiesByIdController.definition.url
            .replace('{site}', parsedArgs.site.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Site\GetSiteActivitiesByIdController::__invoke
* @see app/Http/Controllers/Site/GetSiteActivitiesByIdController.php
* @route '/api/site/{site}/activities'
*/
GetSiteActivitiesByIdController.get = (args: { site: string | number | { id: string | number } } | [site: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetSiteActivitiesByIdController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Site\GetSiteActivitiesByIdController::__invoke
* @see app/Http/Controllers/Site/GetSiteActivitiesByIdController.php
* @route '/api/site/{site}/activities'
*/
GetSiteActivitiesByIdController.head = (args: { site: string | number | { id: string | number } } | [site: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetSiteActivitiesByIdController.url(args, options),
    method: 'head',
})

export default GetSiteActivitiesByIdController